function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0115 25.1632C7.44927 25.1632 5.36538 27.266 5.36538 29.8464C5.36538 32.4267 7.44926 34.5296 10.0115 34.5296C12.5738 34.5296 14.6577 32.4268 14.6577 29.8465C14.6577 27.2661 12.5738 25.1632 10.0115 25.1632ZM10.0115 32.4164C8.60816 32.4164 7.46382 31.2644 7.46382 29.8465C7.46382 28.4285 8.60816 27.2766 10.0115 27.2766C11.4149 27.2766 12.5592 28.4285 12.5592 29.8465C12.5592 31.2643 11.4149 32.4164 10.0115 32.4164Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9886 25.1632C34.4263 25.1632 32.3424 27.266 32.3424 29.8464C32.3424 32.4267 34.4263 34.5296 36.9886 34.5296C39.5508 34.5296 41.6347 32.4268 41.6347 29.8465C41.6347 27.2661 39.5508 25.1632 36.9886 25.1632ZM36.9886 32.4164C35.5852 32.4164 34.4409 31.2644 34.4409 29.8465C34.4409 28.4285 35.5852 27.2766 36.9886 27.2766C38.3919 27.2766 39.5363 28.4285 39.5363 29.8465C39.5363 31.2643 38.3919 32.4164 36.9886 32.4164Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7229 19.2127L36.7231 19.2128C37.1317 19.543 37.6433 19.7234 38.1647 19.7234H39.6862C41.4913 19.7234 42.8824 20.5674 43.8179 21.8021C44.7509 23.0335 45.2316 24.653 45.2316 26.2199C45.2316 28.8855 43.2323 30.903 40.5855 30.903C40.0051 30.903 39.5362 30.4284 39.5362 29.8463C39.5362 29.2642 40.0051 28.7896 40.5855 28.7896C41.8593 28.7896 43.1332 27.9086 43.1332 26.2197C43.1332 25.3304 42.8984 24.2263 42.3471 23.3496C41.7993 22.4787 40.9439 21.8366 39.6862 21.8366H38.1665C37.1681 21.8366 36.1889 21.4894 35.4123 20.8604L35.4124 20.8605L35.5065 20.7437L35.4121 20.8603L36.7229 19.2127ZM36.7229 19.2127L29.637 13.4972L29.6369 13.4971C28.8155 12.8358 27.7842 12.4704 26.7336 12.4704H13.7343C12.1765 12.4704 10.7323 13.2503 9.8684 14.5558L9.86833 14.5559L8.338 16.8729C8.33795 16.873 8.3379 16.8731 8.33786 16.8731C7.90676 17.5224 7.18738 17.9102 6.41448 17.9102C3.85222 17.9102 1.76833 20.013 1.76833 22.5933V26.2199C1.76833 28.8002 3.85222 30.903 6.41448 30.903C6.99486 30.903 7.46374 30.4285 7.46374 29.8464C7.46374 29.2642 6.99484 28.7898 6.41448 28.7898C5.01112 28.7898 3.86678 27.6378 3.86678 26.2199V22.5933C3.86678 21.1754 5.01112 20.0234 6.41448 20.0234C7.89323 20.0234 9.26368 19.2834 10.0844 18.0432L10.0844 18.0431L11.6149 15.7276C12.0891 15.0113 12.8822 14.5835 13.7343 14.5835H26.7336C27.3104 14.5835 27.8744 14.7837 28.3264 15.1469L36.7229 19.2127Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 0.3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33.3916 28.7898H13.6085C13.0281 28.7898 12.5592 29.2643 12.5592 29.8465C12.5592 30.4286 13.0281 30.9031 13.6085 30.9031H33.3917C33.9721 30.9031 34.4409 30.4286 34.4409 29.8465C34.4409 29.2643 33.972 28.7898 33.3916 28.7898Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 0.3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5931 19.7234H23.6499V17.1535C23.6499 16.5713 23.1811 16.0968 22.6007 16.0968C22.0203 16.0968 21.5514 16.5713 21.5514 17.1535V20.7801C21.5514 21.3622 22.0203 21.8367 22.6007 21.8367H31.5931C32.1734 21.8367 32.6423 21.3622 32.6423 20.7801C32.6423 20.1979 32.1734 19.7234 31.5931 19.7234Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 0.3
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5069 19.7235L14.5485 17.6265L14.5487 17.6262C14.806 17.1051 14.5972 16.4715 14.079 16.2092L14.079 16.2092L14.0784 16.2089C13.5579 15.9486 12.93 16.1586 12.6701 16.6826L12.6701 16.6826L10.872 20.3085C10.8719 20.3086 10.8719 20.3087 10.8718 20.3088C10.7081 20.635 10.7274 21.0255 10.9177 21.3355C11.1084 21.6461 11.4461 21.8368 11.81 21.8368H19.0038C19.5842 21.8368 20.0531 21.3623 20.0531 20.7801C20.0531 20.198 19.5843 19.7235 19.0039 19.7235H13.5069Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 0.3
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1977 23.35H24.3993C23.8189 23.35 23.35 23.8245 23.35 24.4067C23.35 24.9888 23.8189 25.4633 24.3993 25.4633H26.1977C26.7781 25.4633 27.247 24.9888 27.247 24.4067C27.247 23.8245 26.7781 23.35 26.1977 23.35Z",
  fill: "current",
  stroke: "current",
  strokeWidth: 0.3
});

function SvgCustomCarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCarIcon);
export default __webpack_public_path__ + "static/media/CustomCarIcon.ba145272.svg";
export { ForwardRef as ReactComponent };